import { render, staticRenderFns } from "./GalleriesUpload.vue?vue&type=template&id=661dd623&scoped=true&"
import script from "./GalleriesUpload.vue?vue&type=script&lang=js&"
export * from "./GalleriesUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661dd623",
  null
  
)

export default component.exports